'use strict';

module.exports = {
  _langData: {},
  _langDataFallback: {},
  locale: '',
  localeFallback: '',

  load: function({langData, langDataFallback, locale, localeFallback, defaultLocale}) {
    this._langData = langData;
    this._langDataFallback = langDataFallback;
    this.locale = locale.toLowerCase();
    this.localeFallback = localeFallback.toLowerCase();
    this.defaultLocale = defaultLocale.toLowerCase();
  },

  // retrieve a string from the localization array
  // supports params e.g. if there is an entry [welcome]='hello :name'
  // you can use lang.get('welcome', {name: 'coolman'}) to return 'welcome coolman'
  get: function(key, paramsObj) {
    let ret = this._langData[key];
    if (typeof ret !== 'undefined')
      return this._parseParams(ret, paramsObj);

    ret = this._langDataFallback[key];
    if (typeof ret !== 'undefined')
      return this._parseParams(ret, paramsObj);

    // TODO Extra info on form is added as locationid in lang-files
    if (typeof key === "number") {
      return '';
    }

    console.warn('Invalid lang key \'' + key + '\' used.');
    return '';
  },

  // capitalization and pluralization not supported
  _parseParams: function(str, paramsObj) {
    if (typeof paramsObj !== 'object') return str;

    let newStr = str;
    Object.keys(paramsObj).forEach(key => {
      const value = paramsObj[key];
      const re = new RegExp(':' + key + '(?!\\w)');
      newStr = str.replace(re, value);
    });
    return newStr;
  }
};
